import { render, staticRenderFns } from "./DriverOverviewList.vue?vue&type=template&id=e54eb7a0"
import script from "./DriverOverviewList.vue?vue&type=script&lang=js"
export * from "./DriverOverviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports